// 视频管理
import http from "@/jslibs/axios/http";

// 视频列表
export const list = (data) => http.get(`/v1/cms/video`, data);

// 视频添加
export const add = (data) => http.post(`/v1/cms/video`, data);

// 视频编辑
export const edit = ({ uuid, ...data }) => http.put(`/v1/cms/video/${uuid}`, data);

// 视频详情
export const detail = ({ cuuid, ...data }) => http.get(`/v1/cms/video/${cuuid}`, data);

// 视频删除
export const del = ({ cuuid }) => http.delete(`/v1/cms/video/${cuuid}`);